// 终止当前请求提示标识
export const ERR_AXIOS_CANCEL_CODE = 'ERR_AXIOS_CANCEL_CODE';
